import { createSlice } from '@reduxjs/toolkit';
import type { PriceSubscriptionState } from './types';

const initialState: PriceSubscriptionState = {
  isSubscribed: false,
};

const priceSubscription = createSlice({
  name: 'priceSubscription',
  initialState,
  reducers: {
    setIsSubscribedOnPrice: (state) => {
      state.isSubscribed = true;
    },
  },
});

export const { setIsSubscribedOnPrice } = priceSubscription.actions;

export const { name } = priceSubscription;

export default priceSubscription.reducer;
